<mat-toolbar>
    <a class="home" routerLink="/">
        <img src="assets/icons/logo.png" />
    </a>
</mat-toolbar>
<div class="flex column align-center root">
    <div class="flex column align-space-between flex-40">
        <h1>Create Workspace</h1>
        <p>Workspaces are the central containers for sharing content with others</p>

        <form class="flex column" (ngSubmit)="submit()">
            <mat-form-field appearance="fill">
                <mat-label>Workspace Name</mat-label>
                <input matInput [formControl]="nameControl" />
            </mat-form-field>
        </form>
        <button mat-flat-button color="primary" (click)="submit()" [disabled]="!nameControl.valid">
            Next
        </button>
    </div>
</div>
